import AiAssitant from '@quark/ai-assistant';
import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import '@quark/ai-assistant/dist/index.css';
import styles from './index.module.scss';
import cn from 'classnames';
import useProfile from '../../hooks/use-profile';
import { HIDE_ASSISTANT_EVENT } from '../../constants';

interface AssistantWrapperProps {
  children: ReactNode;
}

const AssistantWrapper: FC<AssistantWrapperProps> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const profile = useProfile();
  const show = useMemo(() => {
    return true;
    // return [6, 20714, 36498].includes(profile?.user_id || 0);
  }, [profile])

  const toggleVisible = () => {
    setVisible(!visible);
  }

  useEffect(() => {
    const hide = () => {
      setVisible(false);
    }
    window.addEventListener(HIDE_ASSISTANT_EVENT, hide);

    return () => {
      window.removeEventListener(HIDE_ASSISTANT_EVENT, hide);
    }
  }, [visible]);

  return (
    <>
      {children}

      {show && (
        <div
          className={cn(styles.assistant, visible && styles.visible)}
          onClick={toggleVisible}
        >
          {visible ? (
            <div className={styles.close}></div>
          ) : (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" fill="#ffffff" />
              <g id="Frame">
                <g id="Vector">
                  <path d="M4.89613 18.48L8.47213 17.352C8.66412 17.28 8.85613 17.184 9.00013 17.016L18.4561 6.86398C19.6321 5.61598 19.5601 3.67198 18.3121 2.49598C17.0641 1.34398 15.1201 1.41598 13.9441 2.66398L4.48813 12.792C4.34413 12.96 4.24812 13.152 4.20012 13.344L3.33613 17.04C3.12012 17.952 3.98413 18.768 4.89613 18.48ZM14.8321 3.47998C15.5281 2.73598 16.7281 2.68798 17.4721 3.38398C18.2161 4.07998 18.2641 5.27998 17.5681 6.02398L16.8721 6.76798L14.2321 4.12798L14.8321 3.47998ZM5.37613 13.632L13.4161 5.01598L16.0561 7.65598L8.11213 16.176L4.53612 17.304L5.37613 13.632ZM20.0881 20.568H2.92813C2.59212 20.568 2.32812 20.832 2.32812 21.168C2.32812 21.504 2.59212 21.768 2.92813 21.768H20.0881C20.4241 21.768 20.6881 21.504 20.6881 21.168C20.6881 20.832 20.4241 20.568 20.0881 20.568Z" fill="#5562F4" />
                  <path d="M14.8321 3.47998C15.5281 2.73598 16.7281 2.68798 17.4721 3.38398C18.2161 4.07998 18.2641 5.27998 17.5681 6.02398L16.8721 6.76798L14.2321 4.12798L14.8321 3.47998Z" fill="#CCD8FF" />
                  <path d="M5.37613 13.632L13.4161 5.01598L16.0561 7.65598L8.11213 16.176L4.53612 17.304L5.37613 13.632Z" fill="#CCD8FF" />
                </g>
              </g>
            </svg>
          )}
        </div>
      )}

      <div
        className={cn(styles.modal, visible && styles.visible)}
      >
        <AiAssitant
          onUpdate={() => setVisible(true)}
          onClose={() => setVisible(false)}
        />
      </div>
    </>
  )
}

export default AssistantWrapper;
